export const EthersConstantsUtil = {
    WALLET_ID: '@w3m/wallet_id',
    ERROR_CODE_UNRECOGNIZED_CHAIN_ID: 4902,
    ERROR_CODE_DEFAULT: 5000
};
//# sourceMappingURL=EthersConstantsUtil.js.map